export const tabsContent = {
  items: [
    {
      imageContent_1: [
        { imageSrc: "/assets/stock-img/compliances_logo_01.webp" },
        { imageSrc: "/assets/stock-img/compliances_logo_02.webp" },
        { imageSrc: "/assets/stock-img/compliances_logo_03.webp" },
        { imageSrc: "/assets/stock-img/compliances_logo_04.webp" },
        { imageSrc: "/assets/stock-img/compliances_logo_05.webp" },
      ],

      imageContent_2: [
        { imageSrc: "/assets/stock-img/compliances_logo_01.webp" },
        { imageSrc: "/assets/stock-img/compliances_logo_02.webp" },
        { imageSrc: "/assets/stock-img/compliances_logo_03.webp" },
        { imageSrc: "/assets/stock-img/compliances_logo_04.webp" },
        { imageSrc: "/assets/stock-img/compliances_logo_05.webp" },
      ],

      imageContent_3: [
        { imageSrc: "/assets/stock-img/compliances_logo_01.webp" },
        { imageSrc: "/assets/stock-img/compliances_logo_02.webp" },
        { imageSrc: "/assets/stock-img/compliances_logo_03.webp" },
        { imageSrc: "/assets/stock-img/compliances_logo_04.webp" },
        { imageSrc: "/assets/stock-img/compliances_logo_05.webp" },
      ],

      imageContent_4: [
        { imageSrc: "/assets/stock-img/compliances_logo_01.webp" },
        { imageSrc: "/assets/stock-img/compliances_logo_02.webp" },
        { imageSrc: "/assets/stock-img/compliances_logo_03.webp" },
        { imageSrc: "/assets/stock-img/compliances_logo_04.webp" },
        { imageSrc: "/assets/stock-img/compliances_logo_05.webp" },
      ],
    },
  ],
};